import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { AXE_FLAG_OPTIONS } from '@/pages/instruments/new-instrument/constants/axe-flags'

export interface AxeFlagFormFieldProps {}

export const AxeFlagFormField: React.FC<AxeFlagFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ axe_flag: string | null }>()

  return (
    <FormField
      name="axe_flag"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Axe Flag</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              showNone="None"
              placeholder={'Select an axe flag...'}
              value={value?.toString()}
              setValue={(value) =>
                setValue('axe_flag', value ? value : null, { shouldValidate: true })
              }
              options={AXE_FLAG_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
